import { makeImmutable, optionalEq } from "../../core";
import { ModifierItemPackagingVariantId } from "../Identifiers";
export class ModifierItemInstance {
    constructor(params) {
        this.modifierType = params.modifierType;
        this.modifierItemType = params.modifierItemType;
        this.quantity = params.quantity;
        this.defaultQuantity = params.defaultQuantity;
        this.modifierItemPackagingFeeId = params.modifierItemPackagingFeeId;
        makeImmutable(this);
    }
    get isSelected() {
        return this.quantity.value > 0;
    }
    eq(other) {
        return (this.typeId.eq(other.typeId) &&
            this.quantity.eq(other.quantity) &&
            optionalEq(this.modifierItemPackagingFeeId, other.modifierItemPackagingFeeId));
    }
    get typeId() {
        return this.modifierItemType.id;
    }
    get variantKey() {
        return new ModifierItemPackagingVariantId(this.typeId, this.modifierItemPackagingFeeId);
    }
}
